// extracted by mini-css-extract-plugin
var _1 = "download-document-container__KBiSw";
export { _1 as "downloadDocumentContainer" }
